"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_PERIOD_BY_TITLE = exports.getOriginalDate = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const types_1 = require("./types");
const getOriginalDate = (value) => {
    if (value.length) {
        const date = (0, dayjs_1.default)(value);
        if (date.isValid())
            return date.toDate();
    }
    return null;
};
exports.getOriginalDate = getOriginalDate;
exports.DATE_PERIOD_BY_TITLE = {
    [types_1.EDatePeriods.AllTime]: [null, null],
    [types_1.EDatePeriods.Day]: [(0, dayjs_1.default)().startOf('date').toDate(), (0, dayjs_1.default)().toDate()],
    [types_1.EDatePeriods.Week]: [
        (0, dayjs_1.default)().subtract(1, 'week').startOf('date').toDate(),
        (0, dayjs_1.default)().toDate(),
    ],
    [types_1.EDatePeriods.Month]: [
        (0, dayjs_1.default)().subtract(1, 'month').startOf('date').toDate(),
        (0, dayjs_1.default)().toDate(),
    ],
    [types_1.EDatePeriods.ThreeMonths]: [
        (0, dayjs_1.default)().subtract(3, 'month').startOf('date').toDate(),
        (0, dayjs_1.default)().toDate(),
    ],
};
//# sourceMappingURL=index.js.map